<template>
  <div class="account-page">
    <div class="container">
      <Navbar />
      <AccountPage :userInfo="user" />
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Header/Navbar.vue";
import AccountPage from "@/components/Account/AccountPage.vue";
export default {
  name: "Account",
  components: {
    Navbar,
    AccountPage,
  },
  data() {
    return {
      user: {
        uId: "",
        uUserId: "",
        uName: "",
        uEmail: "",
        uPassword: "",
        uMemberSince: "",
        uAddress: "",
        uPhone: "",
        uRole: "",
        uRoleIs: "",
      },
    };
  },
  mounted() {
    let user = localStorage.getItem("current-user-data");
    if (user) {
      this.user.uName = JSON.parse(user).name;
    } else {
      this.$router.push({ name: "Login" });
    }
  },
  methods: {},
};
</script>
